import { 
    CONNECTION_SERVER, 
} from './types';


export const connection = dados => {
    // console.log('connection',dados)
    return { type: CONNECTION_SERVER, payload: dados }
}